import { render } from "./CargaPlanillaNovedades.vue?vue&type=template&id=6163c8de"
import script from "./CargaPlanillaNovedades.vue?vue&type=script&lang=js"
export * from "./CargaPlanillaNovedades.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__